import { FamilyRules, OpportunityKey, Reward } from '../types/family';

export function rewardVisibleTo(r: Reward, memberId: string): boolean {
  if (r.paused) return false;
  return !r.availableFor || r.availableFor.includes(memberId);
}

export function rewardEnabledFor(r: Reward, memberId: string): boolean {
  return !r.availableFor || r.availableFor.includes(memberId);
}

/** Nov seznam otrok, ki vidijo nagrado, ko skrbnik za enega otroka vklopi ali izklopi. */
export function toggleRewardFor(r: Reward, memberId: string, kidIds: string[]): string[] | undefined {
  const current = r.availableFor ?? kidIds;
  const next = current.includes(memberId) ? current.filter((id) => id !== memberId) : [...current, memberId];
  return kidIds.every((id) => next.includes(id)) ? undefined : next;
}

export function opportunityOn(rules: FamilyRules, key: OpportunityKey): boolean {
  return rules.opportunities?.[key] !== false;
}

export const opportunityLabels: Record<OpportunityKey, { label: string; hint: string }> = {
  roomDay: { label: 'Urejena soba med tednom', hint: 'Goodies za urejeno sobo na dan poleg sobote.' },
  extraMinutes: { label: 'Dodatne minute', hint: 'Goodies za branje ali vadbo nad dnevnim ciljem.' },
  sharedCare: { label: 'Skupna skrb za živali', hint: 'Goodies za oskrbo živali brez stalnega skrbnika.' },
  offers: { label: 'Pomoč drugim', hint: 'Prevzem opravila, ki ga ponudi drug član.' },
};
